import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  canonical?: string;
  ogImage?: string;
  keywords?: string;
  noindex?: boolean;
}

export function SEO({
  title = 'Wlkthru - Video Calling for Service Professionals',
  description = 'wlkthru lets service pros offer video calls before driving out in person. Get fast answers, save miles, close more deals, and invoice with next-day payouts.',
  canonical,
  ogImage = 'https://www.wlkthru.co/lovable-uploads/3b39a7ae-d9ab-4bb2-b53e-362e23c5e771.png',
  keywords = 'wlkthru, video calling, remote inspection, contractor video calls, professional video platform',
  noindex = false,
}: SEOProps) {
  const fullTitle = title.includes('Wlkthru') ? title : `${title} | Wlkthru`;
  const canonicalUrl = canonical || 'https://www.wlkthru.co/';

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:site_name" content="Wlkthru" />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Robots */}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
    </Helmet>
  );
}
